import { ITableColumn, TableColumnTypeEnum, WidthType } from './tableColumn.interface';

export const AuditLogEventsTableColumns: ITableColumn[] = [
  {
    labelPath: 'userManagementPage.auditLogsPage.tableColumns.timestamp',
    propertyKey: 'timestamp',
    colType: TableColumnTypeEnum.DateTime,
    width: 170,
    widthType: WidthType.Pixel,
    isSortable: true,
    sortKey: 'timestamp',
  },
  {
    labelPath: 'userManagementPage.auditLogsPage.tableColumns.objectType',
    propertyKey: 'objectType',
    colType: TableColumnTypeEnum.TextWithIcon,
    width: 150,
    widthType: WidthType.Pixel,
    isSortable: true,
    sortKey: 'entity_type',
    iconSrc: 'iconSrc',
    iconTableClass: 'objectTypeIconClass',
  },
  {
    labelPath: 'userManagementPage.auditLogsPage.tableColumns.actorEmail',
    propertyKey: 'actorEmail',
    colType: TableColumnTypeEnum.Avatar,
    width: 140,
    widthType: WidthType.Pixel,
    isSortable: true,
    sortKey: 'actor.email',
  },
  {
    labelPath: 'userManagementPage.auditLogsPage.tableColumns.action',
    propertyKey: 'action',
    colType: TableColumnTypeEnum.Text,
    width: 120,
    widthType: WidthType.Pixel,
    isSortable: true,
    sortKey: 'entity_action',
  },
  {
    labelPath: 'userManagementPage.auditLogsPage.tableColumns.actorType',
    propertyKey: 'actorType',
    colType: TableColumnTypeEnum.Text,
    width: 100,
    widthType: WidthType.Pixel,
    isSortable: true,
    sortKey: 'actor.source',
  },
  {
    labelPath: 'userManagementPage.auditLogsPage.tableColumns.objectId',
    propertyKey: 'objectId',
    colType: TableColumnTypeEnum.CopyableText,
    width: 80,
    widthType: WidthType.Pixel,
    isSortable: true,
    sortKey: 'id',
    withCopyIcon: true,
    iconOnly: true,
  },
  {
    labelPath: 'userManagementPage.auditLogsPage.tableColumns.details',
    propertyKey: 'details',
    colType: TableColumnTypeEnum.TextPopup,
    width: 100,
    widthType: WidthType.Pixel,
    isSortable: false,
  },
];
